import { navigate, useLocation } from "../lib/router";
import { Switch } from "./Switch";

/** Whether a list shows its archived agents, scopes or types: off by default, kept in the address (?archived=1) like every filter. */
export function useShowArchived(): [boolean, (on: boolean) => void] {
  const { pathname, search } = useLocation();
  const set = (on: boolean) => {
    const q = new URLSearchParams(search);
    if (on) q.set("archived", "1");
    else q.delete("archived");
    const rest = q.toString();
    navigate(rest ? `${pathname}?${rest}` : pathname, true);
  };
  return [search.get("archived") === "1", set];
}

/** The switch itself, the same on every list; `count` says how many are hidden, when the list knows. */
export function ShowArchived({ on, onChange, count }: { on: boolean; onChange: (on: boolean) => void; count?: number }) {
  return <Switch size="sm" checked={on} onChange={onChange} label={count ? `Show archived · ${count}` : "Show archived"} />;
}
